// Compressed CDN project image (auto-generated via sharp)
export const FLOW_SCREED_1 =
  "https://assets.cdn.filesafe.space/iehMW4z3GZgoPjqmxz5p/media/6ab288347f434ba2c07a137d.webp";
export const FLOW_SCREED_2 =
  "https://assets.cdn.filesafe.space/iehMW4z3GZgoPjqmxz5p/media/6ab2883430b0f957cce046c1.webp";
export const FLOW_SCREED_3 =
  "https://assets.cdn.filesafe.space/iehMW4z3GZgoPjqmxz5p/media/6ab288374091fa65e6d0d406.webp";
